import { render, staticRenderFns } from "./EmailTemplatesList.vue?vue&type=template&id=a8132134&scoped=true"
import script from "./EmailTemplatesList.vue?vue&type=script&lang=ts"
export * from "./EmailTemplatesList.vue?vue&type=script&lang=ts"
import style0 from "./EmailTemplatesList.vue?vue&type=style&index=0&id=a8132134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8132134",
  null
  
)

export default component.exports